import {CURRENCY_CODE} from "../vendor/qconstants";

console.log('Executing util.js...');

import {getCurrentDevice} from '../vendor/breakpoints'
import * as qconst from '../vendor/qconstants';
import {ebus} from '@/vendor/ebus';
// import * as iframe from '../iframe/iframe'

// export const host = window.location.host; //with port
// export const hostNoPort = window.location.hostname; //without port

// export function shallowCloneObject(obj) {
//     return Object.assign({}, obj);
// }
//
// export function shallowCloneArray(arr) {
//     let _arr = [];
//     for (let a = 0; a < arr.length; a++) {
//         _arr.push({...arr[a]});
//     }
// }

export function cloneAndRemoveAllDisplayKeys(objOrArray, propsToDelete) {
  return JSON.parse(JSON.stringify(objOrArray, (k, v) =>
    (typeof k !== 'number' && (k.startsWith('aaa') || k === '$$hashKey' || typeof k !== 'number' && propsToDelete.includes(k))) ? undefined : v));
}

export function offset(el) {
  // if (!el) {
  //     return 0;
  // }
  try {
    let rect = el.getBoundingClientRect(),
      scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
      scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return {top: rect.top + scrollTop, left: rect.left + scrollLeft}
  } catch (e) {
    return 0;
  }
}

// //https://exploringjs.com/deep-js/ch_copying-objects-and-arrays.html
// export function deepCopy(original) {
//     if (Array.isArray(original)) {
//         return original.map(elem => deepCopy(elem));
//     } else if (typeof original === 'object' && original !== null) {
//         return Object.fromEntries(
//             Object.entries(original)
//                 .map(([k, v]) => [k, deepCopy(v)]));
//     } else {
//         // Primitive value: atomic, no need to copy
//         return original;
//     }
// }

export function cloneMe(objOrArray) {
  // let obj = objOrArray;
  // if (Array.isArray(objOrArray)) {
  //     obj = Array.from(objOrArray);
  // }
  try {
    return JSON.parse(JSON.stringify(objOrArray));
  } catch (e) {
    console.log('error in cloneMe: ' + e.message);
    console.trace();
    return objOrArray;
  }

  // return JSON.parse(JSON.stringify(deepCopy(objOrArray)));
}


export function isEmptyObject(jsonString) {
  return Object.keys(jsonString).length === 0;
}

export function clearObject(obj) {
  for (let member in obj) delete obj[member];
}

const accentMap = {
  'á': 'a', 'à': 'a',
  'é': 'e', 'è': 'e',
  'í': 'i', 'ì': 'i',
  'ó': 'o', 'ò': 'o',
  'ú': 'u', 'ù': 'u'
};

export function accentFold(s) {
  if (!s) {
    return '';
  }
  var ret = '';
  for (var i = 0; i < s.length; i++) {
    ret += accentMap[s.charAt(i)] || s.charAt(i);
  }
  return ret;
}

// export function getHourFromSelectedId(selectedId) {
//     if (!selectedId) {
//         return 0
//     }
//     return parseInt(selectedId.substr(0, selectedId.indexOf('-')), 10);
// }

// export function getMinuteFromSelectedId(selectedId) {
//     if (!selectedId) {
//         return 0
//     }
//     return parseInt(selectedId.substr(selectedId.indexOf('-') + 1, 5), 10);
// }

// export function enableNoScroll(enable) {
//     if (enable) {
//         document.getElementById('html').classList.add('noScroll');
//         document.getElementById('body').classList.add('noScroll');
//     } else {
//         document.getElementById('html').classList.remove('noScroll');
//         document.getElementById('body').classList.remove('noScroll');
//     }
// }

export function camelize(str) {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.toLowerCase().slice(1);
}

let _constTimeDiff = -1;

export function getCurrentRemoteTime() {
  return new Date();
  // return new Date(new Date().getTime() + _constTimeDiff);
}

export function addDays(date, days) {
  if (!days) {
    days = 0;
  }
  let result = new Date(date.getTime());
  result.setDate(result.getDate() + days);
  return result;
}

// const monthNamesLong = ["Januar", "Februar", "März", "April", "Mai", "Juni",
//     "July", "August", "September", "Oktober", "November", "Dezember"
// ];

export const monthNamesShort = ["Jan.", "Feb.", "Mär.", "Apr.", "Mai", "Jun.",
  "Jul.", "Aug.", "Sep.", "Okt.", "Nov.", "Dez."
];

export function generatePickupDate(_day, _time) {
  let day = _day;
  let refTime = getCurrentRemoteTime();
  let isAsap = day === 'asap';
  // if (isAsap) {
  //     day = '1';
  //     let h = refTime.getHours();
  //     let m = refTime.getMinutes();
  //     if (m < 45) {
  //         m += 15;
  //     }
  //     let hour = '' + h;
  //     if (h < 10) {
  //         hour = '0' + h;
  //     }
  //     _time = hour + ':' + m;
  // }

  if (day === '1') {
    //today
  } else if (day === '2') {
    //next day / tomorrow
    refTime = addDays(refTime, 1);
  } else if (day === '3') {
    refTime = addDays(refTime, 2);
  }

  let _dayOfMonth = refTime.getDate();//day of month
  let _month = refTime.getMonth();
  let _monthName = monthNamesShort[_month];

  let result = {
    asap: isAsap,
    dayOfMonth: _dayOfMonth,
    month: _month + 1,
    year: refTime.getFullYear(),
    monthName: _monthName,
    time: _time.value, //'00:00'
    utc: _time.utc
  };

  if (day === '1') {
    result.today = 'Heute'
  }

  return result;
}

export function displayPickupDate(pickupDate) {
  return pickupDate.dayOfMonth + '. ' + pickupDate.monthName + ' ' + pickupDate.time + ' Uhr'
}

export function alternativeDisplayPickupDate(selectedDay, time) {
  // if (pickUpTime.asap) {
  //     return 'ASAP'
  // }
  if (selectedDay === 'asap') {
    return 'So schnell wie möglich';
  }

  let day = '';
  if (selectedDay === '1') {
    day = 'Heute, ';
  } else if (selectedDay === '2') {
    day = 'Morgen, ';
  } else if (selectedDay === '3') {
    day = 'Übermorgen, ';
  }

  // let hour = '' + pickUpTime.hour;
  // if (pickUpTime.hour < 10) {
  //     hour = '0' + pickUpTime.hour;
  // }
  //
  // let minute = '' + pickUpTime.minute;
  // if (pickUpTime.minute < 10) {
  //     minute = '0' + pickUpTime.minute;
  // }

  return day + time + ' Uhr'; //time is a string 06:45
}

function _getDayOfWeek(date) {
  let dof = date.getDay();
  //in js 0 = Sonntag und 1 = Montag
  if (dof === 0) {
    dof = 7;
  }
  return dof;
}

export function getNextDay() {
  //ff today is monday(0) it returns the int 1 = Dienstag
  let today = getDayOfWeek(getCurrentRemoteTime());
  return (today === 7) ? 1 : today + 1;
}


export function getDayOfWeek(date) {
  //return 1=Montag, 7=Sonntag, 8 = feiertag
  return _getDayOfWeek(date);
}

export function isWithinPeriod(period, rNow) {

  console.log('??? has period : ', period);

  let _fHour = period.fromHour;
  let _tHour = period.tillHour;
  let _fMinute = period.fromMinute;
  let _tMinute = period.tillMinute;

  let rHour = rNow.getHours();
  let rMinute = rNow.getMinutes();

  if (rHour < _fHour || rHour > _tHour) {
    return false;
  }

  if (rHour !== _fHour && rHour !== _tHour) {
    return true;
  }

  if (rHour === _fHour) {
    return rMinute >= _fMinute;
  }

  // if(rHour === _tHour){
  return rMinute <= _tMinute;
  // }
}

export function isBeforePeriod(period, rNow) {
  if (!period || !rNow) {
    return false;
  }
  var _fHour = period.fromHour;
  var _fMinute = period.fromMinute;

  var rHour = rNow.getHours();
  var rMinute = rNow.getMinutes();

  if (rHour < _fHour) {
    return true;
  }

  if (rHour === _fHour) {
    return rMinute <= _fMinute;
  }

  return false;
}

export function zeroTimeDate(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0);
}

export function getDaysBetween(startDate, endDate) {
  let millisecondsPerDay = 24 * 60 * 60 * 1000;
  return (startDate.getTime() - endDate.getTime()) / millisecondsPerDay;
}

export function initTimeDiff(remoteTime) {
  let now = new Date();
  let rDayOfWeek = remoteTime.day;
  let rMinute = remoteTime.minute;
  if (rMinute < 59) {
    rMinute += 1;
  }
  let rNow = new Date(now.getFullYear(), now.getMonth(), now.getDate(), remoteTime.hour, rMinute);
  let dayOfWeekNow = _getDayOfWeek(rNow);
  if (dayOfWeekNow !== rDayOfWeek) {
    //plus days 1
    rNow = addDays(rNow, 1);
  } else {
    console.log('??? same remote day as rNow');
  }
  let rTime = rNow.getTime();
  let nowTime = now.getTime();
  _constTimeDiff = rTime - nowTime;
  console.log('??? _constTimeDiff in minutes = ' + _constTimeDiff / 60 / 1000);
}

let noscroll = false;

export function setNoscroll(n) {
  noscroll = n;
}

export function jumpToTop(veryTop, afterNav, targetId) {
  let delay = afterNav ? 300 : 1;
  setTimeout(() => {
    console.log('SCROLL TO TOP with noscroll = ' + noscroll);
    if (noscroll) {
      console.log('SCROLL prevented');
      return;
    }

    // if (iframe.isInIframe()) {
    //     iframe.post({event: 'scrollToTop'});
    //     return;
    // }

    // document.body.scrollTop = 0;
    // document.documentElement.scrollTop = 0;
    // document.getElementById(elId).scrollIntoView(true);
    try {
      if (getCurrentDevice() === 'xs') {
        veryTop = true;
      }
      let top = 0;
      if (!veryTop) {
        let el = document.getElementById('scrollTop');
        top = offset(el).top - 36;
      }

      if (targetId) {
        let el = document.getElementById(targetId);
        top = offset(el).top - 67;
      }

      if (top < 1) {
        top = 0;
      }

      if (top === window.scrollY) {
        return;
      }

      window.scrollTo({
        top: top,
        left: 0,
        behavior: 'smooth'
      });

    } catch (e) {
      // alert('Error scroll jump ' + e.message);
    }
  }, delay);
}

// //https://github.com/vuetifyjs/vuetify/issues/6962
// export function bugfixTabWindowHeight() {
//     //v-window__container--is-active
//     let vw = document.getElementsByClassName('v-window__container--is-active');
//     if (vw && vw.length > 0) {
//         console.log('??? update win height to auto');
//         vw[0].style.height = 'auto';
//     }
// }

export function delayScroll(elId,
                            topOffset //optional
) {

  setTimeout(() => {
    // document.getElementById(elId).scrollIntoView(true);
    let el = document.getElementById(elId);
    let o = 140;
    if (topOffset) {
      o = topOffset;
    }
    window.scrollTo({
      top: offset(el).top - o,
      left: 0,
      behavior: 'smooth'
    });
  }, 400);
}

export function roundToTwo(num) {
  try {
    return parseFloat(num.toFixed(2));
    // return +(Math.round(num + "e+2") + "e-2");
  } catch (e) {
    return 0;
  }
}

export function generateClientId() {
  return Date.now() + '_' + Math.random().toString(36).substring(2, 5);
  // return Math.random().toString(36).substring(2)
  //     + (new Date()).getTime().toString(36);
}

export function randomInt(min, max) { // min and max included
  return Math.floor(Math.random() * (max - min + 1) + min);
}

export function getLocalPrice(price, forceDisplay) {
  if (!price && !forceDisplay) {
    return '';
  }
  //https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString
  //Internationalisierung
  return price.toLocaleString(navigator.language, {
    style: 'currency',
    currency: CURRENCY_CODE,
    minimumFractionDigits: 2,
  });
}

export function safeGet(obj, key) {
  try {
    return key.split('.').reduce(function (result, key) {
      return result[key]
    }, obj);
  } catch (e) {
    return null;
  }
}

export function getDateDisplay(createdAt) {
  if (!createdAt) {
    return '';
  }
  // Wir erzwingen das deutsche Format ('de-DE')
  return new Date(createdAt + _constTimeDiff).toLocaleString('de-DE');
}

export function getUhrzeit(utc) {
  let date = new Date(utc);
  let hour = '' + date.getHours();
  if (hour.length === 1) {
    hour = '0' + hour;
  }
  let minute = '' + date.getMinutes();
  if (minute.length === 1) {
    minute = '0' + minute;
  }
  return hour + ':' + minute;
}

export function groupBy(list, propName) {
  if (!list) {
    return [];
  }
  return list.reduce(function (r, a) {
    r[a[propName]] = r[a[propName]] || [];
    r[a[propName]].push(a);
    return r;
  }, Object.create(null));
}

export function calculateZielterminOfToday(delayInMinutes) {
  let utc = Date.now() + (delayInMinutes * 60 * 1000);
  return new Date(utc);
  // let remoteUtc = getCurrentRemoteTime().getTime();
  // return new Date(remoteUtc + (delayInMinutes * 60 * 1000));
}

export function calcDelayInMinutes(baseDely, cartItems) {
  let highestDelay = baseDely ? baseDely : 5; //default delay = 5 minutes
  for (let itm of cartItems) {
    if (itm.delay && itm.delay > highestDelay) {
      highestDelay = itm.delay;
    }
  }
  console.log('highestDelay = ' + highestDelay);
  return highestDelay;
}

export function calculateZieltermin(order) {
  if (!order.pickupDate) {
    return 0;
  }
  if (!order.pickupDate.asap) {
    return new Date(order.pickupDate.utc);
    // let pt = order.pickupDate;
    // let time = pt.time.split(':');
    // let hour = time[0];
    // let minute = time[1];
    // return new Date(pt.year, pt.month - 1, pt.dayOfMonth, hour, minute);
  }

  if (order.targetTime) {
    return new Date(order.targetTime);
  } else {
    return new Date(order.createdAt + (order.delayInMinutes * 60 * 1000) + _constTimeDiff);
  }
}

export function displayDayMonth(date) {
  if (!date) {
    return '';
  }
  let dayOfMonth = '' + date.getDate();
  // if (dayOfMonth.length === 1) {
  //     dayOfMonth = '0' + dayOfMonth;
  // }
  let month = '' + (date.getMonth() + 1);
  // if (month.length === 1) {
  //     month = '0' + month;
  // }
  return dayOfMonth + '.' + month;
}

export function getNowWithZeroTime(date) {
  if (!date) {
    date = new Date();
  }
  return new Date(getISO8601Date(date) + 'T00:00:00.000Z').getTime();
}

export function getISO8601Date(date) {
  // ISO 8601 date strings (YYYY-MM-DD)
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000)
    .toISOString()
    .split('T')[0];
  // return date.toISOString().split('T')[0];
  // return date.toISOString().substr(0, 10)
  // let year = '' + date.getFullYear();
  // let dayOfMonth = '' + date.getDate();
  // if (dayOfMonth.length === 1) {
  //     dayOfMonth = '0' + dayOfMonth;
  // }
  // let month = '' + (date.getMonth() + 1);
  // if (month.length === 1) {
  //     month = '0' + month;
  // }
  // return year + '-' + month + '-' + dayOfMonth;
}

// export function displayDate(date, short) {
//     if (!date) {
//         return '';
//     }
//     try {
//         let dayOfMonth = '' + date.getDate();
//         // if (dayOfMonth.length === 1) {
//         //     dayOfMonth = '0' + dayOfMonth;
//         // }
//         let month = '' + (date.getMonth() + 1);
//         // if (month.length === 1) {
//         //     month = '0' + month;
//         // }
//
//         let year = '' + date.getFullYear();
//         if (short) {
//             year = year.substring(2, 4);
//         }
//
//         return dayOfMonth + '.' + month + '.' + year
//     } catch (e) {
//         console.log('Error in displayDate: ' + e.message);
//         return '';
//     }
// }

// export function shortDateDisplay(date, zirka, ab) {
//     if (!date) {
//         return '';
//     }
//     try {
//         let hour = '' + date.getHours();
//         if (hour.length === 1) {
//             hour = '0' + hour;
//         }
//         let minute = '' + date.getMinutes();
//         if (minute.length === 1) {
//             minute = '0' + minute;
//         }
//
//         let add = ', ';
//         if (zirka) {
//             add = ', ca. '
//         } else if (ab) {
//             add = ', ab '
//         }
//
//         let ddate = displayDate(date, true);
//
//         return ddate + add + hour + ':' + minute;
//     } catch (e) {
//         console.log('Error in shortDateDisplay: ' + e.message);
//         return '';
//     }
// }


// export function getOrtKey(ort) {
//     return ort.trim().replace(/\s/g, '-').replace(/'/g, '').toLowerCase();
// }

export function removeCharacter(str, pos) {
  let part1 = str.substring(0, pos);
  let part2 = str.substring(pos + 1, str.length);
  return (part1 + part2);
}

// export function calcPayerSum(cartItems) {
//     let s = 0;
//     for (let i of cartItems) {
//         if ('isCoupon' in item) {
//             if (item.type === 'amount') {
//                 s -= item.amount;
//             }
//         } else {
//             s += item.itemTotal;
//         }
//     }
//     if (s < 0) {
//         s = 0;
//     }
//     return s;
// }

export function getSelectedOptions(variant) {
  let o = [];
  try {
    if (variant.aaaOhne) {
      return o;
      // return 'ohne';
    }
    let anyActive = false;
    for (let opt of variant.options) {
      if (opt.active || !('active' in opt) || opt.aaaSelected) {
        anyActive = true;
      }
    }
    if (!anyActive) {
      return o;
    }
    for (let opt of variant.options) {
      if (opt.aaaSelected) {
        o.push(opt);
        // return opt;
      }
    }
    if (o.length > 0) {
      return o;
    }
    if (variant.multi || variant.optional || (variant.trigger && !variant.show)) {
      return 'aaaOhne';
    }
    return '-1'; // means, user must select something
  } catch (e) {
    console.log('Error in getSelectedOptions: ' + e.message);
    return o;
  }

}

export function getExtraPrice(extra, volName) {
  if ('volCosts' in extra) {
    let first = null;
    for (let vc of extra.volCosts) {
      if (!first) {
        first = vc.cost;
      }
      if (vc.volName === volName) {
        return vc.cost;
      }
    }
    return first;
  }
  return extra.cost;
}

export function getArtikelnummerOfItem(item) {
  let code = '';
  if (item.articleNo) {
    code = item.articleNo;
  }
  if (item.extras && item.extras.variants) {
    for (let s of item.extras.variants) {
      if (s.multi || !s.replaceArticle) {
        continue;
      }
      let selectedOptions = getSelectedOptions(s);
      for (let so of selectedOptions) {
        if (so instanceof Object) {
          if (so.articleNo) {
            code = so.articleNo;
            break;
          }
        }
      }

    }
  }
  return code;
}

export function displayCouponType(item) {
  if (item.nameToDisplay) {
    return item.nameToDisplay;
  }
  if (item.couponCode || item.type === 'individual') {
    return item.title
  }
  // if(item.type === 'discount'){
  return 'Coupon'
}

export function displayOpeningHour(dayItem, fromOrTill) {
  var hour = dayItem[fromOrTill + 'Hour'];
  if (hour < 10) {
    hour = '0' + dayItem[fromOrTill + 'Hour'];
  }
  var minute = dayItem[fromOrTill + 'Minute'];
  if (minute < 10) {
    minute = '0' + dayItem[fromOrTill + 'Minute'];
  }
  return hour + ':' + minute;
}

export function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}

export function getWeekdayAsNum() {
  let day = (new Date()).getDay();
  // Sunday is 0, Monday is 1
  if (day === 0) {
    day = 7;
  }
  return day;
}

export const weekday = new Array(8);
weekday[1] = 'Mo';
weekday[2] = 'Di';
weekday[3] = 'Mi';
weekday[4] = 'Do';
weekday[5] = 'Fr';
weekday[6] = 'Sa';
weekday[7] = 'So';

export const fullWeekday = new Array(8);
fullWeekday[1] = 'Montag';
fullWeekday[2] = 'Dienstag';
fullWeekday[3] = 'Mittwoch';
fullWeekday[4] = 'Donnerstag';
fullWeekday[5] = 'Freitag';
fullWeekday[6] = 'Samstag';
fullWeekday[7] = 'Sonntag';

export function getDayNumFromWeekday(wd) {
  let i = 1;
  for (let d of weekday) {
    if (d === undefined) {
      continue;
    }
    if (d === wd) {
      return i;
    }
    i++;
  }
  return i;
}

export function removeSpaces(v) {
  if (!v || v === 'undefined') {
    return '';
  }
  return ('' + v).replace(/\s/g, '');
  //Postleizahl Leerzeichen entfernen
}

export function removeEmptyProps(obj) {
  let propsToRemove = [];
  Object.keys(obj).forEach((prop) => {
    let v = obj[prop];
    if (typeof v === 'undefined') {
      propsToRemove.push(prop);
    } else if (typeof v === 'string') {
      if (v.length < 1
        || v === 'null'
        || v === 'undefined') {
        propsToRemove.push(prop);
      }
    }
  });
  for (let prop of propsToRemove) {
    delete obj[prop];
  }
}

export function isPhoneKeydown(e) {
  return (e.keyCode === 8 // backspace
    || e.keyCode === 9 //tab
    || e.keyCode === 12 //clear
    || e.keyCode === 16 //shift
    || e.keyCode === 35 //ende
    || e.keyCode === 36 //pos1
    || e.keyCode === 37 //arrow left
    || e.keyCode === 39 //arrow right
    || e.keyCode === 16 //shift
    || e.keyCode === 45 //einfügen
    || e.keyCode === 46 // delete
    || e.keyCode === 107 //+
    || /\d| +/.test(e.key));
}

//trims all props of type string and sets undefined to '
export function sanitizeProps(obj, doRemoveSpaces) {
  if (obj) {
    if (Array.isArray(obj)) {
      for (let item of obj) {
        sanitizeProps(item, doRemoveSpaces);
      }
      return
    }

    Object.keys(obj).forEach((prop) => {
      if (prop === '__proto__') {
        return;
      }
      let v = obj[prop];
      if (typeof v === 'string') {
        if (v === 'null' || v === 'undefined') {
          obj[prop] = '';
        }
      }
      if (typeof v === 'string' || typeof v === 'undefined') {
        //only trim specific specific props
        if (prop === 'name' || prop === 'company' || prop === 'street' || prop === 'city'
          || prop === 'note' || prop === 'etage') {
          try {
            obj[prop] = v.trim();
          } catch (e) {
            obj[prop] = '';
          }
        } else {
          if (doRemoveSpaces) {
            obj[prop] = removeSpaces(v);
          }
        }
      } else if (typeof v === 'object') {
        sanitizeProps(v, doRemoveSpaces);
      }
    });
  }
}

export function mapEquals(m1, m2, ignoreKeys) {
  let eq = true;
  try {
    // if (fillPropsNotEqual) {
    //   propsNotEqual = [];
    // }
    Object.keys(m1).forEach((key) => {
      if (key !== '__proto__' && (!ignoreKeys || !ignoreKeys.includes(key))) {
        let v1 = m1[key];
        let v2 = null;
        if (m2) {
          v2 = m2[key];
        }
        if (!!v1 && typeof v1 === 'object') {
          if (!mapEquals(v1, v2, ignoreKeys)) {
            // propsNotEqual.push({prop: key, value1: v1, value2: v2});
            eq = false;
          }
        } else {
          // console.log('va1 = ' + JSON.stringify(v1));
          // console.log('va2 = ' + JSON.stringify(v2));
          if (!(!v2 && !v1) && (!v1 || JSON.stringify(v2) !== JSON.stringify(v1))) {
            // if (fillPropsNotEqual) {
            //   propsNotEqual.push({prop: key, value1: v1, value2: v2});
            // }
            eq = false;
          }
        }
      }
    });
  } catch (e) {
    console.log('error in mapEquals: ' + e.message);
  }
  return eq;
}

export function bottomVisible() {
  //@see https://techstacker.com/javascript-detect-when-scrolled-to-bottom/
  return (window.innerHeight + window.pageYOffset >= document.body.offsetHeight - 240);
}

export function calcDiscount(size, discount) {
  //discountPrice = price * (100 - discount) / 100
  return roundToTwo(size.price * (100 - discount) / 100);
}

export function noEuro(r) {
  r = r.replaceAll(CURRENCY_CODE, '').trim();
  return r;
}

export function isSameDay(first, second) {
  return first.getFullYear() === second.getFullYear() &&
    first.getMonth() === second.getMonth() &&
    first.getDate() === second.getDate();
}

export function withoutSplits(s) {
  let r = s;
  if (s.includes('|')) {
    r = s.substring(0, s.indexOf('|'));
  }
  return r;
}

export function filteredExtras(item) {
  try {
    if (item.extras && item.extras.variants) {
      for (let step of item.extras.variants) {
        if (!step.options) {
          continue;
        }
        for (let i = 0; i < step.options.length; i++) {
          let option = step.options[i];
          if (typeof option.active !== 'undefined' && !option.active) {
            step.options.splice(i--, 1);
            console.log('optionfilter spliced');
          }
        }
      }
    }
  } catch (e) {
    console.log('Error in filteredExtras: ' + e.message);
  }

  return item;
}

export function doReload(reason) {
  console.log('Reloading. Reason:', reason);

  try {
    // Nutze die URL API - sie ist in Capacitor 8 garantiert vorhanden
    const url = new URL(window.location.href);

    // Setzt/Überschreibt den Parameter sicher
    url.searchParams.set('reloadTime', Date.now().toString());

    // WICHTIG: Nutze replace() statt href
    // 1. Verhindert "Zurück-Button" Endlosschleifen
    // 2. Erzeugt einen sauberen neuen Request in der WebView
    window.location.replace(url.toString());

  } catch (err) {
    // Minimalistischer Fallback, falls die URL-API bei extrem seltsamen
    // lokalen Pfaden scheitert
    const joiner = window.location.href.includes('?') ? '&' : '?';
    window.location.replace(window.location.href + joiner + 'reloadTime=' + Date.now());
  }
}

export function removeAllQueryParams() {
  //remove the query parameter
  let hash = '' + window.location.hash; // #/Welcome
  let path = window.location.pathname;// /
  let newurl = window.location.host + path + hash;
  newurl = newurl.replaceAll('//', '/');
  if (window.location.protocol.indexOf('s') === -1) {
    newurl = 'http://' + newurl;
  } else {
    newurl = 'https://' + newurl;
  }
  console.log('newurl = ' + newurl);
  window.history.replaceState('', document.title, newurl); // added this line to push the new url directly to url bar .
}

export function isKilled(order) {
  return order.storno
    || order.state === qconst.orderState$Rejected
    || order.state === qconst.orderState$Cancelled;
}

export function isTakeawayForNow(o) {
  if (!o) {
    console.log('isTakeawayForNow return false 1');
    return false;
  }
  if (!o.usecase === qconst.usecase$tableOrdering && !o.usecase === qconst.usecase$inhouseMobilePayment) {
    console.log('isTakeawayForNow return false 2');
    return false;
  }
  let targetTime = o.targetTime;
  if (!targetTime) {
    o.targetTime = o.createdAt + (14 * 60 * 1000);
    // console.log('isTakeawayForNow return false 2');
    // return false;
  }
  // if the order is a preorder when it is more than 60 minutes in advance
  let diff = Date.now() - targetTime;
  if ((diff > (-20 * 60 * 1000)) && (diff < (5 * 60 * 1000))) {
    console.log('isTakeawayForNow return true');
    return true;
  }
}

export function isEmailOk(v) {
  return v && (/.+@.+[.].+/.test(v) === true)
}

export function isMobileOk(v) {
  return v && (v.length >= 8); //Belgium has 8+. Ther EU countries have more
}

export function isPlzOk(v) {
  return (v && v.match(/^\d+$/));
}

export function getStreetAndNumberError(v) {
  if (!v || v.length < 4) {
    return 'Die Straße ist erforderlich';
  }

  if ((/\d/.test(v) === false) || v.indexOf(' ') === -1) {
    return 'Die Hausnummer fehlt';
  }
  return '';
}

export function getName2Error(v) {
  if (!v || v.length < 4 || v.indexOf(' ') < 2 || v.indexOf(' ') === v.length - 1) {
    return 'Bitte Vor- und Nachname eingeben';
  }
  return false;
}

export function getName1Error(v) {
  if (!v || v.length < 2) {
    return 'Bitte einen Namen eingeben';
  }
  return false;
}

export function sanitizeEmail(email) {
  try {
    return email.replace(/\s+/g, '').toLowerCase();
  } catch (e) {
    return email;
  }
}

export function sanitizePhone(phone) {
  try {
    if (!phone || phone === 'undefined' || phone === '+49undefined') {
      return '';
    }
    let tPhone = '' + phone;
    if (tPhone.startsWith('00')) {
      tPhone = '+' + tPhone.substring(2, tPhone.length);
      //results in +490176
    } else if (!tPhone.startsWith('+')) {
      tPhone = '+49' + tPhone;
    }
    // if (!this.formData.phone.startsWith('+')) {
    //     this.formData.phone = '+' + this.formData.phone;
    // }

    //remove all spaces
    tPhone = tPhone.replace(/\s/g, '');
    if (tPhone.startsWith('+') && tPhone.length >= 4 && tPhone.charAt(3) === '0') {
      //remove the zero after the country
      tPhone = removeCharacter(tPhone, 3);
    }
    return tPhone;
  } catch (e) {
    return phone;
  }
}

export function phoneKeydown(e) {
  //allow backspace, tab and entfernen
  if (e.keyCode === 8 // backspace
    || e.keyCode === 9 //tab
    || e.keyCode === 12 //clear
    // || e.keyCode === 13 //clear
    || e.keyCode === 16 //shift
    || e.keyCode === 35 //ende
    || e.keyCode === 36 //pos1
    || e.keyCode === 37 //arrow left
    || e.keyCode === 39 //arrow right
    || e.keyCode === 16 //shift
    || e.keyCode === 45 //einfügen
    || e.keyCode === 46 // delete
    || e.keyCode === 107 // plus
    || /\d| +/.test(e.key)) {

  } else {
    e.preventDefault();
  }
}

export function stringAToUtc(str) {
  //"2023-07-20T21:59:59.000Z"
  try {
    return new Date(str).getTime();
  } catch (e) {
    return Date.now();
  }
}

// export function rerender(flag){
//     flag = false;
//     setTimeout(()=>{
//         flag = true;
//     },400)
// }

//https://flaviocopes.com/javascript-dates/
// date.toString() // "Sun Jul 22 2018 07:22:13 GMT+0200 (Central European Summer Time)"
// date.toTimeString() //"07:22:13 GMT+0200 (Central European Summer Time)"
// date.toUTCString() //"Sun, 22 Jul 2018 05:22:13 GMT"
// date.toDateString() //"Sun Jul 22 2018"
// date.toISOString() //"2018-07-22T05:22:13.000Z" (ISO 8601 format)
// date.toLocaleString() //"22/07/2018, 07:22:13"
// date.toLocaleTimeString()	//"07:22:13"
// date.getTime() //1532236933000
// date.getTime() //1532236933000

export function clearTheInterval(iv) {
  try {
    clearInterval(iv);
    console.log('clearTheInterval completed');
  } catch (e) {
    console.log('catched error in clearTheInterval: ' + e.message);
  }
}

export function clearTheTimeout(timeout) {
  try {
    clearTimeout(timeout);
    console.log('clearTheTimeout completed');
  } catch (e) {
    console.log('catched error in clearTheTimeout: ' + e.message);
  }
}

export function noHtml(text) {
  try {
    if (!text) {
      return '';
    }
    let str = text.replace(/<sup>.*<\/sup>/ig, '');
    let dom = new DOMParser().parseFromString(str, 'text/html');
    return dom.body.textContent;
  } catch (e) {
    return text.replace(/(&lt;([^>]+)>)/gi, ' ');
  }
}

export function clearEvents(names) {
  if (names) {
    for (let n of names) {
      ebus.$off(n);
    }
  }
}

export function orderHasDrinks(orderData) {
  try {
    let items = orderData || [];
    let found = false;
    for (let i of items) {
      if ((i.type || '') === qconst.type$drinkOrder) {
        found = true;
      }
    }
    return found;
  } catch (e) {
    console.log('Error in orderHasDrinks: ' + e.message);
    return true;
  }
}

export function orderHasFoods(orderData) {
  try {
    let items = orderData || [];
    let found = false;
    for (let i of items) {
      if ((i.type || '') === qconst.type$foodOrder) {
        found = true;
      }
    }
    return found;
  } catch (e) {
    console.log('Error in orderHasFoods: ' + e.message);
    return true;
  }
}

export function getUtcFromDateTime(dateStr, timeStr) {
  //dateStr = 2020-ß6-05
  //timeStr = 15:33
  let hour = timeStr.substring(0, 2);
  let minute = timeStr.substring(3, 5);
  let year = dateStr.substring(0, 4);
  let month = dateStr.substring(5, 7);
  let day = dateStr.substring(8, 10);
  // if (!startOfDay) {
  //     hour = 23;
  //     minute = 59;
  // }
  let date = new Date(year, month - 1, day, hour, minute);
  return date.getTime();
}

export function shortDateDisplay(date) {
  if (!date) {
    return '';
  }
  try {
    let dayOfMonth = '' + date.getDate();
    if (dayOfMonth.length === 1) {
      dayOfMonth = '0' + dayOfMonth;
    }
    let month = '' + (date.getMonth() + 1);
    if (month.length === 1) {
      month = '0' + month;
    }
    let year = ('' + date.getFullYear()).substring(0, 4);
    return dayOfMonth + '.' + month + '.' + year;
  } catch (e) {
    console.log('error in shortDateDisplay: ' + e.message);
    return '';
  }
}

function body() {
  return document.getElementsByTagName('BODY')[0];
}

export function disableScrolling() {
  body().classList.add('disable-scrolling');
}

export function enableScrolling() {
  body().classList.remove('disable-scrolling');
}

function getAgent() {
  return navigator.userAgent || navigator.vendor || window.opera || '';
}

export function isSafari() {
  return /^((?!chrome|android).)*safari/i.test(getAgent());
}

export function isIos() {
  let agent = getAgent();
  try {
    return (agent.match(/iPad/i) || isIphone() || isSafari() || agent.match(/iPod/i));
  } catch (e) {
    return false
  }
}

export function isIphone() {
  try {
    return /iPhone/i.test(getAgent());
  } catch (e) {
    return false
  }
}

export function isWindows() {
  try {
    return /Windows/i.test(getAgent());
  } catch (e) {
    return false
  }
}

export function closeSoftKeyBoard() {
  try {
    if (isIphone()) {
      // Create a dummy input element
      const dummyInput = document.createElement('input');
      dummyInput.setAttribute('type', 'text');

      // Append the dummy input element to the body
      document.body.appendChild(dummyInput);

      // Programmatically focus on the dummy input element
      dummyInput.focus();

      // Programmatically blur the dummy input element
      dummyInput.blur();

      // Remove the dummy input element from the body
      document.body.removeChild(dummyInput);
    } else {
      // For other devices, simply blur the active element
      document.activeElement.blur();
    }
  } catch (e) {

  }
}

export function insertQueryParam(key, _value) {
  let value = '' + _value;
  key = encodeURIComponent(key.trim());
  value = encodeURIComponent(value.trim());

  // kvp looks like ['key1=value1', 'key2=value2', ...]
  let kvp = document.location.search.substring(1).split('&');
  let i = 0;

  for (; i < kvp.length; i++) {
    if (kvp[i].startsWith(key + '=')) {
      let pair = kvp[i].split('=');
      pair[1] = value;
      kvp[i] = pair.join('=');
      break;
    }
  }

  if (i >= kvp.length) {
    kvp[kvp.length] = [key, value].join('=');
  }

  // can return this or...
  let params = kvp.join('&');
  if (params.startsWith('&')) {
    params = params.substring(1, params.length);
  }

  //replace all spaces
  params = params.replace(/\s/g, '');

  // if (kvp.length === 2) {
  //   params = params.substring(1, params.length);
  // }

  // reload page with new params
  let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + params
    + window.location.hash;
  window.history.pushState({path: newurl}, '', newurl);
  // document.location.search = params;
}

export function removeAllLinks(text) {
  return text.replace(/href="([^"]+)"/g, 'href="#"');
}

export function spacifyString(text) {
  if (!text) {
    return '';
  }
  let t = text.replaceAll(',', ', ');
  t = t.replace('  ', ' ');
  return t;
}

export function isInteger(n) {
  return n === +n && n === (n | 0);
}

export function parseTableOrNull(t) {
  try {
    if (typeof t === 'string') {
      t = t.trim();
    }
    let p = parseInt(t)
    return p;
  } catch (e) {
    return null;
  }
}

export function removeDuplicatesByProperty(list, propertyName) {
  let seen = {};
  return list.filter(function (item) {
    let propertyValue = item[propertyName];
    return seen.hasOwnProperty(propertyValue) ? false : (seen[propertyValue] = true);
  });
}

export function removeDuplicatesFromStringList(arr) {
  // Check if input is an array
  if (!Array.isArray(arr)) {
    throw new TypeError('Input must be an array');
  }
  // Create a Set to remove duplicates
  return Array.from(new Set(arr));
}

export async function createBlobFromURL(fileURL) {
  try {
    // Fetch the file data using the file URL
    const response = await fetch(fileURL);

    // Check if the fetch was successful
    if (!response.ok) {
      throw new Error(`Failed to fetch the file. Status: ${response.status}`);
    }

    // Get the array buffer from the response
    const arrayBuffer = await response.arrayBuffer();

    // Create a Blob from the array buffer
    const blob = new Blob([arrayBuffer]);

    console.log("Blob created successfully:", blob);

    return blob;
  } catch (error) {
    console.error("Error creating Blob from URL:", error);
    throw error;
  }
}

export async function saveAsBlob(blob, fileName) {
  try {
    // saveAs(blob, filename);
    let type = mime.lookup(fileName);
    let ext1 = mime.extension(type);
    let ext2 = '.' + ext1;
    console.log('downloadFile filetype ' + type + ' for filename ' + fileName);
    let accept = {};
    accept[type] = [ext2];

    console.log('downloadFile trigger showSaveFilePicker for ext1 ' + ext1);
    let fileHandle = await window.showSaveFilePicker({
      suggestedName: fileName,
      types: [
        {
          description: ext1 + ' File',
          accept: accept,
        },
      ],
      id: 'downloadArea',
    });

    const writable = await fileHandle.createWritable();
    await writable.write(blob);
    await writable.close();
  } catch (e) {
    console.log('error in saveFile: ' + e.message);
  }
}

export function downloadFile(url, fileName) {
  if (!!window.showSaveFilePicker) {
    console.log('downloadFile with showSaveFilePicker');
    createBlobFromURL(url).then(blob => {
      console.log('downloadFile blob created');
      saveAsBlob(blob, fileName);
    });
  } else {
    console.log('downloadFile with saveFile');
    saveFile(url, fileName);
  }
}

export function saveFile(url, filename) {
  try {
    // Trigger the "Save As" dialog box
    saveAs(url, filename);
  } catch (e) {
    console.log('error in saveFile: ' + e.message);
  }
}

export function isToday(timestamp) {
  const inputDate = new Date(timestamp);
  const today = new Date();

  return inputDate.getDate() === today.getDate() &&
    inputDate.getMonth() === today.getMonth() &&
    inputDate.getFullYear() === today.getFullYear();
}

export function getUniqueListBy(arr, key) {
  return [...new Map(arr.map(item => [item[key], item])).values()]
}

export function fullscreenMode(enable) {
  if (!enable) {
    document.exitFullscreen();
    return;
  }

  // var elem = document.getElementById(id);
  let elem = document.documentElement;
  //document.getElementsByTagName('BODY')[0];
  if (elem.requestFullscreen) {
    elem.requestFullscreen();
  } else if (elem.mozRequestFullScreen) { /* Firefox */
    elem.mozRequestFullScreen();
  } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
    elem.webkitRequestFullscreen();
  } else if (elem.msRequestFullscreen) { /* IE/Edge */
    elem.msRequestFullscreen();
  }
}
